import { render, staticRenderFns } from "./CertificateEdit.vue?vue&type=template&id=5986f73a&scoped=true&"
import script from "./CertificateEdit.vue?vue&type=script&lang=js&"
export * from "./CertificateEdit.vue?vue&type=script&lang=js&"
import style0 from "./CertificateEdit.vue?vue&type=style&index=0&id=5986f73a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5986f73a",
  null
  
)

export default component.exports